export default {"src":"/_next/static/image/public/images/ic_radio_checked_green.c70c300afdc7cab781b4bd06b605c86c.svg","height":16,"width":16};